import { styled } from '@linaria/react';

import {
  DemoRadioControl,
  DemoSliderControl,
} from '@/components/Demo';

import FlexDemo from './FlexDemo';
import { Reflection } from './Item';
import Output from './Output';

function GapIntro() {
  return (
    <FlexDemo
      initialValues={{
        '--direction': 'row',
        gap: 4,
      }}
      controls={[
        <DemoRadioControl
          key="--direction"
          id="--direction"
          label="flex-direction"
          options={['row', 'column']}
          wrapperStyle={{
            width: 284,
          }}
        />,
        <DemoSliderControl
          key="gap"
          id="gap"
          label="gap"
          min={0}
          max={48}
          previewRenderer={(val) => `${val}px`}
          wrapperStyle={{
            width: 284,
          }}
        />,
      ]}
    >
      {(state) => {
        const isRow = state['--direction'] === 'row';
        const Item = isRow ? RowItem : ColItem;

        return (
          <Output state={state}>
            <Item layout={false} style={{ flexBasis: 64 }}>
              <Reflection />
            </Item>
            <Item layout={false} style={{ flexBasis: 64 }}>
              <Reflection />
            </Item>
            <Item layout={false} style={{ flexBasis: 64 }}>
              <Reflection />
            </Item>
            {isRow && (
              <Item layout={false} style={{ flexBasis: 64 }}>
                <Reflection />
              </Item>
            )}
          </Output>
        );
      }}
    </FlexDemo>
  );
}

const PseudoItem = styled.div`
  position: relative;
  border: 2px solid var(--color-gray-500);
  background-color: var(--color-gray-100);
`;

const RowItem = styled(PseudoItem)`
  margin: 2px 0px;

  &:first-of-type {
    margin-left: 2px;
    border-radius: 4px 0px 0px 4px;
  }
  &:last-of-type {
    margin-right: 2px;
    border-radius: 0px 4px 4px 0px;
  }
`;

const ColItem = styled(PseudoItem)`
  margin: 0px 2px;

  &:first-of-type {
    margin-top: 2px;
    border-radius: 4px 4px 0px 0px;
  }
  &:last-of-type {
    margin-bottom: 2px;
    border-radius: 0px 0px 4px 4px;
  }
`;

export default GapIntro;
